module.exports = __webpack_public_path__ + "eb2b5f815c362630d6e6a0952884f327.png";